import {useEffect} from "react"
import {objectLang} from "./functions"

export const HtmlLangSetter = () => {
    useEffect(() => {
        let langLowerCase = objectLang().language.lang
        if (!langLowerCase) {
            langLowerCase = 'en'
        }
        const langUpperCase = langLowerCase.toUpperCase()
        document.documentElement.lang = `${langLowerCase}-${langUpperCase}`
    }, [])

    return null
}
